import Config from '../config';
import Storage from '../services/api/store';
import CONSTANT from '../constant';
import JSSHA from 'jssha';


class Analytics {

    constructor(trackingId, options) {
        this.trackingId = trackingId;
        this.gaVersion = 1;
        this.baseUrl = 'https://www.google-analytics.com';
        this.debugUrl = '/debug';
        this.collectUrl = '/collect';
        this.batch = '/batch';

        this.config(options);
    }

    setCid(cid) {
        return this.cid = cid;
    }

    setDebug(debug) {
        this.debug = debug;
    }

    setUid(uid) {
        this.uid = uid;
    }

    setAppName(appName) {
        this.appName = appName;
    }

    setAppVersion(appVersion) {
        this.appVersion = appVersion;
    }

    setLanguage(language) {
        this.language = language;
    }

    config(config = {
        debug: false,
        uid: null,
        appName: '',
        appVersion: '',
        language: ''
    }) {
        this.setDebug(config.debug);
        this.setUid(config.uid);
        this.setAppName(config.appName);
        this.setAppVersion(config.appVersion);
        this.setLanguage(config.language);
    }

    url() {
        if (this.debug) {
            return `${this.baseUrl}${this.debugUrl}${this.collectUrl}`;
        }
        return `${this.baseUrl}${this.collectUrl}`;
    }

    params() {
        const params = {
            v: this.gaVersion,
            tid: this.trackingId,
            cid: this.cid,
            ul: this.language,
            an: this.appName,
            av: this.appVersion
        };
        if (this.uid) {
            params.uid = this.uid;
        }
        return params;
    }

    send(params) {
        if (this.debug) {
            // console.info({ analytics: params });
        }
        if (params && this.trackingId && navigator.onLine) {

            const searchParams = Object.keys(params).map((key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
            }).join('&');

            fetch(new Request(this.url(), {
                method: 'post',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: searchParams
            }));
        }
    }

    screenview(cd, options = {}) {
        this.send(Object.assign(
            this.params(),
            options,
            {
                t: 'screenview',
                cd
            }
        ));
    }

    event(ec, ea, options = {}) {
        this.send(Object.assign(
            this.params(),
            options,
            {
                t: 'event',
                ec,
                ea
            }
        ));
    }
}

const getUid = () => {
    const user = Storage.get(CONSTANT.USER_INFO_KEY);
    if (user && user.id) {
        return user.id;
    }
    return null;
};

const SHA = (str) => {
    let shaObj = new JSSHA("SHA-1", "TEXT");
    shaObj.update(str);
    let  hash = shaObj.getHash("HEX");
    return hash;
}

const analytics = new Analytics('UA-111711661-1', {
    debug: (!IS_BUILD_TEST && !IS_BUILD_PRODUCTION),
    appName: 'mblock',
    appVersion: Config.appVersion,
    language: Storage.get(CONSTANT.INTL_LANG_KEY) || navigator.language,
    uid: getUid()
});

if (window.MbApi && window.MbApi.machineId) {
    window.MbApi.machineId({ original: true }).then(id => analytics.setCid(SHA(id)));
} else {
    analytics.setCid('debug');
}

export const setLanguage = analytics.setLanguage;
export const setUid = analytics.setUid;
export const trackPage = (page, options) => {
    analytics.screenview(page, options);
};
export const trackEvent = (category, action, options) => {
    analytics.event(category, action, options);
};